import React from 'react';

import styles from './FeatureLabels.css';

export function FeatureLabels({ children }: React.PropsWithChildren<{}>) {
  return <div className={styles['container']}>{children}</div>;
}
